<template>
  <div class="cropper t-a-center">
    <vueCropper
      ref="cropper"
      :img="imgUrl"
      :autoCrop="true"
      :fixedNumber="[1, 1]"
      :fixed="false"
      :canScale="false"
      :outputType="'png'"
      :fixedBox="false"
      :outputSize='1'
      :maxImgSize='3000'
      :full="true">
    </vueCropper>
  </div>
</template>

<style scoped>
  .cropper {
    width: auto;
    height: 400px;
  }
</style>

<script>
export default {
  name: 'UiCropper',

  props: {
    imgUrl: {
      type: String,
      required: true
    }
  }
};
</script>